import {
  Pause as PauseIcon,
  PlayArrow as PlayArrowIcon,
  SkipNext as SkipNextIcon,
  SkipPrevious as SkipPreviousIcon,
} from '@mui/icons-material';
import { Button, IconButton, Slider, Stack, Typography } from '@mui/material';
import { alpha } from '@mui/material/styles';
import { format } from 'date-fns';

export function EventReplayControls({
  onSkipPreviousClick,
  onSkipNextClick,
  onPlayPauseClick,
  onSliderChange,
  onFramesPerSecondClick,
  isPlaying,
  totalFrames = 1,
  framesPerSecond = 1,
  frame = 0,
  frameTime = new Date('2000-01-01T00:00:00Z'),
}) {
  if (totalFrames <= 1) {
    return null;
  }

  return (
    <Stack
      direction="row"
      spacing={0.5}
      sx={(theme) => ({
        alignItems: 'center',
        position: 'absolute',
        minWidth: 360,
        bottom: 48,
        right: 120,
        left: 120,
        p: 0.5,
        bgcolor: alpha(theme.palette.background.paper, 0.8),
        borderRadius: 8,
      })}
    >
      <IconButton onClick={onSkipPreviousClick} size="small">
        <SkipPreviousIcon />
      </IconButton>
      <IconButton onClick={onPlayPauseClick} size="small">
        {isPlaying ? <PauseIcon /> : <PlayArrowIcon />}
      </IconButton>
      <IconButton onClick={onSkipNextClick} size="small">
        <SkipNextIcon />
      </IconButton>
      <Button
        onClick={onFramesPerSecondClick}
        size="small"
      >{`${framesPerSecond} FPS`}</Button>
      <Typography variant="caption" sx={{ textWrap: 'nowrap' }}>
        {format(frameTime, 'dd/MM/yyyy HH:mm:ss')}
      </Typography>
      <Slider
        sx={{
          mx: 2,
          '& .MuiSlider-mark': {
            bgcolor: '#bfbfbf',
            height: 6,
            width: '1px',
            '&.MuiSlider-markActive': {
              opacity: 1,
              bgcolor: 'currentColor',
            },
          },
        }}
        value={frame}
        step={1}
        min={0}
        max={totalFrames - 1}
        onChange={onSliderChange}
        marks
      />
    </Stack>
  );
}
